import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Loader2 from 'lucide-react/dist/esm/icons/loader-2.js';
import { useSiteConfig } from '../contexts/SiteConfigContext';

/**
 * Route guard that prevents access to purchase and checkout routes when a draw is closed.
 * If the current draw is closed, drawing, or unavailable, redirects immediately to /closed.
 */
export default function DrawOpenRoute({ children }) {
  const { isDrawClosed, loading } = useSiteConfig();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isDrawClosed) {
      navigate('/closed', { replace: true });
    }
  }, [loading, isDrawClosed, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
      </div>
    );
  }

  if (isDrawClosed) {
    return <Navigate to="/closed" replace />;
  }

  return children;
}
